import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 6L8.32083 11.3643C8.23516 11.4513 8.11997 11.5 8 11.5C7.88003 11.5 7.76484 11.4513 7.67917 11.3643L2.5 6",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgChevronDown;
